import React from 'react'
import Footer from '../footer'
import Avbar from '../navbar/Navbar'
import './main.css'
import "/node_modules/bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/css/bootstrap.min.css";
import ProjectCards1 from './ProjectCards'
import "./Card.css";


function ProjectsMain() {
  return (
    <>
      <Avbar />
      <ProjectCards1 />
      <Footer />
    </>

  )
}

export default ProjectsMain
